/*
 *  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  * No part of this publication may be reproduced, distributed,
 *  * or transmitted in any form or by any means, including photocopying, recording,
 *  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  * except in the case of brief quotations embodied in critical
 *  * reviews and certain other noncommercial uses permitted by copyright law.
 *  *  author : BS
 *  *  date : 3/14/23, 6:08 PM
 */

import { ActionNoticeBadgeEnum } from '../../enum/action-notice-badge.enum';
import { StandardAction } from '../../tool/action/standard-action';

export class StandardActionBuilder {
  readonly _standardAction: StandardAction;

  constructor(name: string, icon: string) {
    this._standardAction = new StandardAction(name, icon);
    return this;
  }

  public setEnable(enable: boolean): StandardActionBuilder {
    this._standardAction.enable = enable;
    return this;
  }

  public enable(): StandardActionBuilder {
    this._standardAction.enable = true;
    return this;
  }

  public disable(): StandardActionBuilder {
    this._standardAction.enable = false;
    return this;
  }

  public displayText(): StandardActionBuilder {
    this._standardAction.showText = true;
    return this;
  }

  public hideText(): StandardActionBuilder {
    this._standardAction.showText = false;
    return this;
  }

  public setShowText(showText: boolean): StandardActionBuilder {
    this._standardAction.showText = showText;
    return this;
  }

  public setText(text: string): StandardActionBuilder {
    this._standardAction.text = text;
    return this;
  }

  public setTooltip(tooltip: string): StandardActionBuilder {
    this._standardAction.tooltip = tooltip;
    return this;
  }

  public setNoticeBadge(noticeBadge: ActionNoticeBadgeEnum) {
    this._standardAction.noticeBadge = noticeBadge;
    return this;
  }

  public setAlign(align: 'left' | 'center' | 'right'): StandardActionBuilder {
    this._standardAction.align = align;
    return this;
  }

  public setFontAwesome(
    fontAwesome: 'fal' | 'fas' | 'far' | 'fad' | 'fat',
  ): StandardActionBuilder {
    this._standardAction.fontAwesome = fontAwesome;
    return this;
  }

  public setIsHighlighted(value: boolean): StandardActionBuilder {
    this._standardAction.isHighlighted = value;
    return this;
  }

  public setHighlightedColor(value: string): StandardActionBuilder {
    this._standardAction.highlightedColor = value;
    return this;
  }

  public setHighlightedBackgroundColor(value: string): StandardActionBuilder {
    this._standardAction.highlightedBackgroundColor = value;
    return this;
  }

  public setBold(value: boolean): StandardActionBuilder {
    this._standardAction.bold = value;
    return this;
  }

  public setIconColor(color: string): StandardActionBuilder {
    this._standardAction.iconColor = color;
    return this;
  }

  public setTextColor(color: string): StandardActionBuilder {
    this._standardAction.textColor = color;
    return this;
  }

  build(): StandardAction {
    return this._standardAction;
  }
}
